import React from 'react'
import { Register } from '@ztechapps/webui.auth'
import type { RegisterSuccessArgs } from '@ztechapps/webui.auth'
import { useFetch } from '@ztechapps/common.hook'
import { getWindow } from '@ztechapps/common.utils'
import { appSettings } from '../../../config/settings'
import { routesDef } from '../../../config/routes'
import { validateWithPhone } from '../ValidateWithPhone'

export const Form = () => {
  const [onLogin] = useFetch(`/api/auth/basic/pp-store/login-no-redirect`, { redirect: 'follow' })

  return (
    <div className="p-sm">
      <Register
        url="/api/auth/basic/pp-store/register"
        initialValues={{ username: '', fullName: '', password: '', phone: '' }}
        validate={validateWithPhone}
        onSuccess={async ({ values: { username, password }, getRecaptchaToken }: RegisterSuccessArgs) => {
          const loginRecaptchaToken = await getRecaptchaToken()
          const { error, ...data } = await onLogin({ username, password, recaptchaToken: loginRecaptchaToken })
          if (error) throw error

          //do a hard redirect here to refresh the tokens
          getWindow().location.href = routesDef.AuthSuccessPage.altPath(data)
        }}
        recaptchaSiteKey={appSettings.Google.recaptchaSiteKey}
        includePassword={true}
      />
    </div>
  )
}
